import { createFileRoute } from "@tanstack/react-router";
import CultivationCheck from "../../app/views/cultivation/cultivationCheck";

const CultivationStart = () => <CultivationCheck cultivationType="lungmask" />;

export const Route = createFileRoute("/lungmask/start")({
  component: CultivationStart,
});
